'use strict';

import React from 'react';

export default function IconPremium (props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#FF7F29"/>
      <path d="M5.83541 13.6648C5.95871 13.6853 6.08349 13.6957 6.20848 13.6957C7.46176 13.6957 8.47774 12.6797 8.47774 11.4264V9.83231C8.47774 9.65327 8.3326 9.50813 8.15356 9.50813H6.06143C6.0122 9.50813 5.96457 9.49063 5.92706 9.45874C5.83975 9.38453 5.82914 9.25359 5.90335 9.16629L9.78061 4.6048C9.81007 4.57014 9.84229 4.53792 9.87694 4.50847C10.2316 4.20698 10.7636 4.25011 11.065 4.6048L14.9423 9.16629C14.9742 9.2038 14.9917 9.25142 14.9917 9.30066C14.9917 9.41524 14.8988 9.50813 14.7842 9.50813H12.6921C12.5131 9.50813 12.3679 9.65327 12.3679 9.83231V11.7774C12.3679 14.1049 10.4811 15.9917 8.15356 15.9917C6.30612 15.9917 5.17281 15.1707 4.69215 13.4742L5.83541 13.6648Z" fill="white"/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Icons/IconPremium.jsx